import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  name: string;
};

export const Layout = (props: Props) => {
  return <div className={`layout ${props.name}`}>{props.children}</div>;
};
